module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter",
      "role": "doc-chapter"
    }
  }, [_c('h1', {
    staticClass: "h1chap"
  }, [_c('span', {
    attrs: {
      "aria-label": "28",
      "epub:type": "pagebreak",
      "id": "page_28",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Chapter 2 "), _c('span', {
    staticClass: "heading_break"
  }, [_vm._v("When Can You Afford to Retire?")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Will you be able to retire by age sixty-five or be stuck working past age seventy? There’s not a simple answer to that question; in fact, there are multiple answers. Two people with the exact same amount of retirement savings today could achieve financial independence years or even decades apart. A multitude of factors affect "), _c('i', [_vm._v("your")]), _vm._v(" answer to that question, from your investment choices to your monthly expenses to physical health. When you know which factors matter more and how to adjust them in your favor, you’ll have more control over your retirement age.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2bd5fffa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781507212257/xhtml/ch02.vue
// module id = 84
// module chunks = 0